import { Button, Grid } from '@atgfr8/atg-ui-tailwind';
import { AutoComplete, SelectInput, MenuItemType } from '@components';
import { createForm } from '@felte/solid';
import { fetchOfficeGroups, updateLoadPropertyAtIndex } from '@store/orders';
import { userStore } from '@store/user';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import { UserAutoComplete } from '@typeDefinitions/userTypes';
import { getDataValue } from '@utils/formUtils';
import { Show, createSignal, onMount } from 'solid-js';

import cls from './classes';

export const AssignLoad = (props: {
  onClose: () => void;
  load: ILoadEditViewModel;
  tabIndex: number;
}) => {
  const [assignLoadOptions, setAssignLoadOptions] =
    createSignal<MenuItemType[]>();

  const getAssignedToGroup = (val: string) => {
    const group = assignLoadOptions()?.find(
      (item) => item.value === String(val),
    );
    return group?.label ?? '';
  };

  const { form, data, setData } = createForm({
    initialValues: {
      assignedToUser: props.load.assignedToUser,
      assignedToUserId: props.load.assignedToUserId,
      assignedToGroupId: props.load.assignedToGroupId,
      assignedToGroup: props.load.assignedToGroup,
    },
    onSubmit: (values) => {
      const {
        assignedToUser,
        assignedToUserId,
        assignedToGroup,
        assignedToGroupId,
      } = values;
      updateLoadPropertyAtIndex({
        assignedToUser: assignedToUser,
        assignedToUserId: assignedToUserId,
        assignedToGroup: assignedToGroup,
        assignedToGroupId: assignedToGroupId,
      });
      props.onClose();
    },
  });

  const handleAssignUser = (item: UserAutoComplete) => {
    const item2 = item as UserAutoComplete;
    setData('assignedToUserId', item2.id);
    setData('assignedToUser', item2.name);
  };

  const handleAssignGroupChange = (value: string) => {
    setData('assignedToGroupId', Number(value));
    setData('assignedToGroup', getAssignedToGroup(value) as string);
  };

  const fetchAssignGroupData = async () => {
    const res = await fetchOfficeGroups(userStore.user.officeId);
    setAssignLoadOptions(
      res.length
        ? res.map((item) => ({
            label: item.name.toString(),
            value: String(item.id),
          }))
        : ([] as MenuItemType[]),
    );
  };

  onMount(() => {
    void fetchAssignGroupData();
  });

  return (
    <form ref={form}>
      <Grid container spacing={4} class={cls.assignLoadContentContainer}>
        <AutoComplete<UserAutoComplete>
          id={`reassign-autocomplete-${props.tabIndex}`}
          endpoint="user/autocomplete?term"
          defaultValue=""
          label="Assign to Person"
          value={getDataValue(data, 'assignedToUser')?.toString()}
          onItemSelect={handleAssignUser}
          renderItem={(item) => {
            return <div>{item.name}</div>;
          }}
        />
        <Show when={assignLoadOptions()?.length}>
          <SelectInput
            label="Assign Group"
            menuItems={assignLoadOptions() ?? []}
            value={
              Boolean(getDataValue(data, 'assignedToGroupId'))
                ? String(getDataValue(data, 'assignedToGroupId'))
                : ''
            }
            onChange={handleAssignGroupChange}
            dataTestId="assign-load-assign-group-select"
          />
        </Show>
      </Grid>
      <Grid class={cls.buttonsContainer}>
        <Button
          class={cls.btn}
          type="submit"
          variant="contained"
          dataTestId="assign-load-submit-button"
        >
          Assign Load
        </Button>
        <Button
          class={cls.btn}
          onClick={() => props.onClose()}
          variant="outlined"
          dataTestId="assign-load-cancel-button"
        >
          Cancel
        </Button>
      </Grid>
    </form>
  );
};
